<template>
  <footer>
    <p id="footer_contact_btn" v-if="this.recruit_check()"><a href="mailto:saiyo2024@tv-asahipro.co.jp" class="btn btn-black">CONTACT</a></p>
    <p id="footer_contact_btn" v-else><router-link to="/contact" class="btn btn-black">CONTACT</router-link></p>
    <div id="footer_inner">
      <p class="policy"><router-link to="/privacypolicy">PRIVACY POLICY</router-link></p>
      <p class="copy">© <span id="js-copy_year">2019</span> テレビ朝日映像</p>
    </div><!-- #footer_inner -->
  </footer>
</template>

<script>
export default {
  name: 'footerItem',
  data (){
    return {
      current_url: location.origin
    }
  },
  mounted () {
    var current_year = new Date().getFullYear();
    document.getElementById('js-copy_year').textContent = current_year;
    var footer = document.getElementsByTagName('footer');
    if (this.recruit_check()){
      $(footer).css('display', 'none');
    }else{
      $(footer).css('display', '');
    }
  },
  watch: {
    '$route' (to, from) {
      var header = document.getElementsByTagName('footer');
      if (this.recruit_check()){
        $(header).css('display', 'none');
      }else{
        $(header).css('display', '');
      }
    }
  },
  methods: {
    recruit_check(){
      return ['recruit_2021','recruit_2022','recruit_2023','recruit_2024','recruit_2025','recruit_2025_application','recruit_2025_teaser','recruit_2025_top','recruit_2026','recruit_2026_application','recruit_2026_top'].includes(this.$route.name)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/common/footerItem.vue